/*
 * @Description:
 * @Author: liangziyao
 * @Date: 2021-08-24 15:44:12
 */
// @param {type, title, text, info, btn} config 
export default {
  activityOver: {
    type: 'tip',
    title: '活動已結束',
    text: '本次活動已經結束，您可以參加G妹遊戲的最新活動哦~！',
    info: '',
    btn: '我知道了'
  },
  login: {
    type: 'login',
    title: '請先登錄',
    text: '您還未登錄，請先登陸之後再參加本活動哦！',
    info: '',
    btn: '去登錄'
  },
  tipBind: {
    type: 'tip',
    title: '提示',
    text: '請您先選擇領取獎勵的遊戲/伺服器/角色哦！',
    info: '',
    btn: '我知道了'
  },
  tipError: {
    type: 'tip',
    title: '抱歉，出錯了',
    text: '抱歉，系統開小差了，請稍後重試。',
    info: '',
    btn: '我知道了'
  },
  eval: {
    type: 'tip',
    title: '提示',
    text: '請您正確選擇領取獎勵的遊戲/伺服器/角色哦！',
    info: '',
    btn: '我知道了'
  },
  tipCommon(text) {
    return {
      type: 'tip',
      title: '提示',
      text: text,
      info: '',
      btn: '我知道了'
    }
  },
  tipSignAward(awardName) {
    return {
      type: 'tip',
      title: '恭喜獲獎',
      text: `恭喜您獲得${awardName}，獎勵將於活動結束的48小時內發送到您的賬號內，請留意。`,
      info: '',
      btn: '我知道了'
    }
  },
  tipLuckyAward(awardName, awardContent) {
    return {
      type: 'tip',
      title: '恭喜獲獎',
      text: `您本次獲得：${awardName}，獎勵為：${awardContent}。<br/>活動結束48小時內，您所獲得的獎勵會以郵件形式發放至您的遊戲內，敬請留意。`,
      info: '',
      btn: '我知道了'
    }
  },
  tipLuckyAwardCode(awardName, awardContent, awardCode) {
    return {
      type: 'luckily',
      title: '恭喜獲獎',
      text: `您本次獲得：${awardName}，獎勵為：${awardContent}。<br/>您的獎勵禮包碼為：${awardCode}，請複製后在遊戲內兌換。`,
      info: '',
      btn: '我知道了'
    }
  }
}
